import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { DishServices } from "../../../../dish/services";
import { Globals } from "../../../../../globals";
import { SchoolServices } from '../../../services';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the MenuPartialDishesSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-classrooms-partial-teachers-select',
    templateUrl: 'classrooms-partial-teachers-select.html',
})
export class ClassroomsPartialTeachersSelectPage {


    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public dishServices: DishServices,
        public globals: Globals,
        private toastCtrl: ToastController,
        public schoolServices: SchoolServices,
        public translate: TranslateService) {

        this.schoolServices.getTeachers(this.globals.school_uid);

    }

    async insert(teacher) {
        //Funcion que añadir al array de platos seleccionados para el menu
        if (!this.check(teacher.UID)) { //Buscamos si el plato ya esta anadido
            var _array = Array();

            _array.push(teacher.UID); //UID
            _array.push(teacher.name);
            _array.push(teacher.email);
            _array.push(teacher.user_uid);

            this.schoolServices.classroom_teachers_array_tmp.push(_array);
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-profesor-esta-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.schoolServices.classroom_teachers_array_tmp.length; i++) {
            var obj = this.schoolServices.classroom_teachers_array_tmp[i];
            if (obj[0] == value) {
                response = true;
            }
        }
        return response;
    }

}


// WEBPACK FOOTER //
// ./src/pages/schools/classrooms-create/classrooms-create-teachers-select/classrooms-partial-teachers-select/classrooms-partial-teachers-select.ts